export default __webpack_public_path__ + "static/media/brain.d556b205.png";